import { useEffect, useState } from 'react';
import { useGetAgreementDocument } from '../hooks/useGetAgreementDocument';
import { useAuthGuard, useAuthHandler } from 'views/auth/useAuth';

import {
  Exact,
  GetAgreementDocumentQuery,
} from 'views/utils/graphql/graphql';
import { UseQueryState } from 'urql';

export type AgreeDocumentModalProps = {
  agreementDocument: UseQueryState<
    GetAgreementDocumentQuery,
    Exact<{
      [key: string]: never;
    }>
  >;
  isOpenAgreementModal: boolean;
  setIsOpenAgreementModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const useAgreementDocumentModal = () : AgreeDocumentModalProps => {
  const [ isOpenAgreementModal, setIsOpenAgreementModal ] = useState<boolean>(false);
  const { agreementDocument, getAgreementDocument } = useGetAgreementDocument({});
  const { isLogin } = useAuthGuard();

  useEffect(() => {
    if (isLogin) {
      getAgreementDocument();
    }
  }, [isLogin]);

  useEffect(() => {
    if (agreementDocument.fetching) return;
    if (!agreementDocument.data?.GetAgreementDocument?.Data) return;
    const data = agreementDocument.data.GetAgreementDocument.Data;
    const hasNotRead = data.some((d) => d?.Read === false);
    if (hasNotRead) {
      setIsOpenAgreementModal(true);
    }
  }, [agreementDocument]);

  return {
    agreementDocument,
    isOpenAgreementModal,
    setIsOpenAgreementModal,
  };
};
